/* LegBilligt — ønskesedlen. Kører på alle sider. */
(function () {
  var K = 'lb_onsker';
  var HUSK = 'lb_setevarer';
  var HJERTE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5S3.5 15 3.5 9.2A4.7 4.7 0 0 1 12 6.4a4.7 4.7 0 0 1 8.5 2.8c0 5.8-8.5 11.3-8.5 11.3z"/></svg>';
  var SIDE = '/pages/oenskeseddel';
  var modtaget = null;
  var cache = {};

  function laes() { try { return JSON.parse(localStorage.getItem(K)) || []; } catch (e) { return []; } }
  function gem(a) { try { localStorage.setItem(K, JSON.stringify(a)); } catch (e) {} }
  function sete() { try { return JSON.parse(localStorage.getItem(HUSK)) || []; } catch (e) { return []; } }
  function kr(n) { return (n / 100).toFixed(2).replace('.', ',') + ' kr'; }

  function hent(h) {
    if (cache[h]) return cache[h];
    cache[h] = fetch('/products/' + h + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[h];
  }

  function husk(h) {
    try {
      var a = sete();
      var i = a.indexOf(h);
      if (i > -1) a.splice(i, 1);
      a.unshift(h);
      localStorage.setItem(HUSK, JSON.stringify(a.slice(0, 12)));
    } catch (e) {}
  }

  function kod(a) {
    try {
      return btoa(unescape(encodeURIComponent(a.join('~')))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    } catch (e) { return ''; }
  }
  function afkod(t) {
    try {
      var b = t.replace(/-/g, '+').replace(/_/g, '/');
      while (b.length % 4) b += '=';
      return decodeURIComponent(escape(atob(b))).split('~').filter(Boolean);
    } catch (e) { return []; }
  }

  function pilStyr(listeId) {
    var l = document.getElementById(listeId);
    if (!l) return;
    var p = l.parentElement ? l.parentElement.querySelector('.lbo-ar') : null;
    if (!p) return;
    var nok = !l.hidden && l.children.length > 3 && l.scrollWidth > l.clientWidth + 8;
    p.classList.toggle('vis', nok);
  }

  function headerHjerte() {
    var kurv = document.getElementById('cart-icon');
    if (!kurv || document.getElementById('lbo-header')) return;
    var a = document.createElement('a');
    a.id = 'lbo-header';
    a.className = 'header__icon lbo-header';
    a.href = SIDE;
    a.setAttribute('aria-label', 'Ønskesedlen');
    a.innerHTML = HJERTE + '<span class="lbo-tal" hidden>0</span>';
    kurv.parentNode.insertBefore(a, kurv);
  }

  function opdaterHeader(puf) {
    var h = document.getElementById('lbo-header');
    if (!h) return;
    var n = laes().length;
    var t = h.querySelector('.lbo-tal');
    if (t) { t.textContent = n; t.hidden = n === 0; }
    h.classList.toggle('paa', n > 0);
    if (puf) { h.classList.remove('puf'); void h.offsetWidth; h.classList.add('puf'); }
  }

  function markerAlle() {
    var a = laes();
    document.querySelectorAll('.lbo-hj,.lbo-pdp').forEach(function (b) {
      var paa = a.indexOf(b.dataset.h) > -1;
      if (b.classList.contains('paa') !== paa) b.classList.toggle('paa', paa);
      var t = b.querySelector('.lbo-pdp-t');
      if (t) {
        var ny = paa ? 'På ønskesedlen ✓' : 'Sæt på ønskesedlen';
        if (t.textContent !== ny) t.textContent = ny;
      }
    });
  }

  function fjernFraForslag(h) {
    var l = document.getElementById('lbo-forslag-liste');
    if (!l) return;
    var knap = l.querySelector('.lbo-hj[data-h="' + h + '"]');
    if (knap) {
      var kort = knap.closest('.lbo-k');
      if (kort) kort.remove();
    }
    var boks = document.getElementById('lbo-forslag');
    if (boks && !l.children.length) boks.hidden = true;
    pilStyr('lbo-forslag-liste');
  }

  function skift(h, b) {
    var a = laes(), i = a.indexOf(h);
    var tilfoejet = i === -1;
    if (i > -1) a.splice(i, 1); else a.push(h);
    gem(a);
    markerAlle();
    opdaterHeader(tilfoejet);
    if (b && tilfoejet) { b.classList.remove('puf'); void b.offsetWidth; b.classList.add('puf'); }
    tegn();
    if (tilfoejet) fjernFraForslag(h);
  }

  function nytHjerte(h) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lbo-hj';
    b.dataset.h = h;
    b.setAttribute('aria-label', 'Sæt på ønskesedlen');
    b.innerHTML = HJERTE;
    return b;
  }

  /* Kortet kan SELV vaere linket til varen (fx .lbbr-p og .lbpk-k),
     eller indeholde linket (product-card, .lbbu-kort). Vi tager begge dele. */
  function handleFra(el) {
    var a = null;
    var eget = el.getAttribute ? el.getAttribute('href') : null;
    if (eget && eget.indexOf('/products/') > -1) a = el;
    if (!a) a = el.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var d = a.getAttribute('href').split('/products/')[1];
    if (!d) return null;
    return d.split('?')[0].split('#')[0].split('/')[0];
  }

  function kortHjerter() {
    document.querySelectorAll('product-card, .lbbr-p, .lbpk-k, .lbbu-kort').forEach(function (k) {
      if (k.querySelector('.lbo-hj')) return;
      var h = handleFra(k);
      if (!h) return;
      var m = k.querySelector('.card__media') || k.querySelector('.im') || k;
      if (getComputedStyle(m).position === 'static') m.style.position = 'relative';
      m.appendChild(nytHjerte(h));
    });
    markerAlle();
  }
  window.lbKortHjerter = kortHjerter;

  function produktHjerte() {
    if (location.pathname.indexOf('/products/') === -1) return;
    var wrap = document.querySelector('.product-info__add-button');
    if (!wrap || document.querySelector('.lbo-pdp')) return;
    var h = location.pathname.split('/products/')[1];
    if (!h) return;
    h = h.split('?')[0].split('/')[0];
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lbo-pdp';
    b.dataset.h = h;
    b.innerHTML = HJERTE + '<span class="lbo-pdp-t">Sæt på ønskesedlen</span>';
    var rk = wrap.closest('.product-info__add-to-cart') || wrap;
    rk.insertAdjacentElement('afterend', b);
    markerAlle();
  }

  function saetBoble(html) {
    var el = document.getElementById('cart-icon-bubble');
    if (!el || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var t = doc.querySelector('.header__cart-count');
    el.innerHTML = t ? t.outerHTML : '';
  }
  window.lbSaetBoble = saetBoble;

  function tilKurv(id, knap, tekst) {
    knap.disabled = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: 'cart-icon-bubble' })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return r.json();
    }).then(function (j) {
      if (j.sections && j.sections['cart-icon-bubble']) saetBoble(j.sections['cart-icon-bubble']);
      knap.classList.add('ok');
      knap.textContent = 'Lagt i kurv ✓';
      setTimeout(function () { knap.classList.remove('ok'); knap.textContent = tekst; knap.disabled = false; }, 2200);
    }).catch(function () {
      knap.textContent = 'Prøv igen';
      setTimeout(function () { knap.textContent = tekst; knap.disabled = false; }, 2200);
    });
  }

  function kortHtml(handle, titel, billed, pris, medFjern) {
    return '<a href="/products/' + handle + '"><span class="im" style="background-image:url(\'' + billed + '\')"></span></a>' +
      '<div class="bd"><a href="/products/' + handle + '"><h4>' + titel + '</h4></a>' +
      '<div class="pr">' + pris + '</div></div>' +
      (medFjern ? '<button class="lbo-x" type="button" data-h="' + handle + '" aria-label="Fjern">&times;</button>' : '');
  }

  function lilleBillede(u) {
    return u ? u.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '';
  }

  function forslag() {
    var boks = document.getElementById('lbo-forslag');
    var liste = document.getElementById('lbo-forslag-liste');
    if (!boks || !liste || boks.dataset.klar) return;
    boks.dataset.klar = '1';

    var paa = laes();
    var mine = sete().filter(function (h) { return paa.indexOf(h) === -1; });

    function faerdig() {
      if (!liste.children.length) { boks.hidden = true; return; }
      markerAlle();
      pilStyr('lbo-forslag-liste');
    }

    if (mine.length >= 2) {
      document.getElementById('lbo-forslag-h').textContent = 'Du kiggede på det her';
      boks.hidden = false;
      Promise.all(mine.slice(0, 8).map(hent)).then(function (ps) {
        ps.filter(Boolean).forEach(function (pd) {
          var el = document.createElement('div');
          el.className = 'lbo-k';
          el.dataset.h = pd.handle;
          el.innerHTML = kortHtml(pd.handle, pd.title, lilleBillede(pd.featured_image), kr(pd.price), false);
          el.appendChild(nytHjerte(pd.handle));
          liste.appendChild(el);
        });
        faerdig();
      });
      return;
    }

    fetch('/collections/bedst-saelgende/products.json?limit=10')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.products || !j.products.length) { boks.hidden = true; return; }
        document.getElementById('lbo-forslag-h').textContent = 'Populært lige nu';
        boks.hidden = false;
        j.products.slice(0, 8).forEach(function (p) {
          if (paa.indexOf(p.handle) > -1) return;
          var billed = p.images && p.images[0] ? lilleBillede(p.images[0].src) : '';
          var pris = p.variants && p.variants[0] ? String(p.variants[0].price).replace('.', ',') + ' kr' : '';
          var el = document.createElement('div');
          el.className = 'lbo-k';
          el.dataset.h = p.handle;
          el.innerHTML = kortHtml(p.handle, p.title, billed, pris, false);
          el.appendChild(nytHjerte(p.handle));
          liste.appendChild(el);
        });
        faerdig();
      })
      .catch(function () { boks.hidden = true; });
  }

  /* Tegner listen INKREMENTELT: kun det kort der er kommet til eller
     forsvundet røres. Resten står helt stille. */
  function tegn() {
    var liste = document.getElementById('lbo-liste');
    if (!liste) return;
    var tom = document.getElementById('lbo-tom');
    var knap = document.getElementById('lbo-knap');
    var linkbox = document.getElementById('lbo-link');
    var a = modtaget || laes();

    forslag();

    if (tom) tom.hidden = a.length > 0;
    liste.hidden = a.length === 0;
    if (knap) knap.hidden = a.length === 0;
    if (linkbox && a.length === 0) linkbox.hidden = true;
    var del = document.getElementById('lbo-del');
    var ryd = document.getElementById('lbo-ryd');
    if (del) del.hidden = !!modtaget;
    if (ryd) ryd.hidden = !!modtaget;

    var harAllerede = {};
    Array.prototype.slice.call(liste.children).forEach(function (el) {
      var h = el.dataset.h;
      if (!h || a.indexOf(h) === -1) { el.remove(); return; }
      harAllerede[h] = true;
    });

    a.forEach(function (h) {
      if (harAllerede[h]) return;
      harAllerede[h] = true;
      hent(h).then(function (pd) {
        if (!pd) return;
        if (laes().indexOf(h) === -1 && !modtaget) return;
        if (liste.querySelector('.lbo-k[data-h="' + h + '"]')) return;
        var v = pd.variants.filter(function (x) { return x.available; })[0] || pd.variants[0];
        var el = document.createElement('div');
        el.className = 'lbo-k';
        el.dataset.h = pd.handle;
        el.innerHTML = kortHtml(pd.handle, pd.title, lilleBillede(pd.featured_image), kr(pd.price), !modtaget) +
          (pd.variants.length > 1
            ? '<a class="lbo-add lbo-add--alt" href="/products/' + pd.handle + '">Vælg variant</a>'
            : '<button class="lbo-add" type="button" data-v="' + (v ? v.id : '') + '">Læg i kurv</button>');
        liste.appendChild(el);
        pilStyr('lbo-liste');
      });
    });

    pilStyr('lbo-liste');
  }

  function start() {
    headerHjerte();
    opdaterHeader(false);
    kortHjerter();
    produktHjerte();

    if (location.pathname.indexOf('/products/') > -1) {
      husk(location.pathname.split('/products/')[1].split('?')[0].split('/')[0]);
    }

    var par = new URLSearchParams(location.search).get('onske');
    if (par) {
      var m = afkod(par);
      if (m.length) {
        modtaget = m;
        var h1 = document.getElementById('lbo-h1');
        var sub = document.getElementById('lbo-sub');
        if (h1) h1.textContent = 'Du har fået en ønskeseddel';
        if (sub) sub.textContent = 'Her er præcis de varer der står på sedlen. Du kan lægge det hele i kurven med ét tryk — eller vælge ud.';
      }
    }
    tegn();

    document.addEventListener('click', function (e) {
      var pil = e.target.closest('.lbo-ar');
      if (pil) {
        var r = document.getElementById(pil.dataset.rail);
        if (r) r.scrollBy({ left: Math.round(r.clientWidth * 0.8), behavior: 'smooth' });
        return;
      }
      var x = e.target.closest('.lbo-x');
      if (x) {
        var a = laes(), i = a.indexOf(x.dataset.h);
        if (i > -1) { a.splice(i, 1); gem(a); markerAlle(); opdaterHeader(false); tegn(); }
        return;
      }
      var add = e.target.closest('.lbo-add[data-v]');
      if (add) { e.preventDefault(); tilKurv(add.dataset.v, add, 'Læg i kurv'); return; }
      var b = e.target.closest('.lbo-hj,.lbo-pdp');
      if (!b || !b.dataset.h) return;
      e.preventDefault();
      e.stopPropagation();
      skift(b.dataset.h, b);
    }, true);

    var ryd = document.getElementById('lbo-ryd');
    if (ryd) ryd.addEventListener('click', function () {
      gem([]); markerAlle(); opdaterHeader(false); tegn();
      var lb = document.getElementById('lbo-link');
      if (lb) lb.hidden = true;
    });

    var del = document.getElementById('lbo-del');
    if (del) del.addEventListener('click', function () {
      var a = laes();
      if (!a.length) return;
      var u = location.origin + SIDE + '?onske=' + kod(a);
      var felt = document.getElementById('lbo-url');
      if (felt) felt.value = u;
      var lb = document.getElementById('lbo-link');
      if (lb) lb.hidden = false;
      try { navigator.clipboard.writeText(u); } catch (e) {}
    });

    var kopi = document.getElementById('lbo-kopi');
    if (kopi) kopi.addEventListener('click', function () {
      var felt = document.getElementById('lbo-url');
      if (!felt) return;
      felt.select();
      try { navigator.clipboard.writeText(felt.value); } catch (e) {}
      kopi.textContent = 'Kopieret ✓';
      setTimeout(function () { kopi.textContent = 'Kopiér'; }, 2000);
    });

    var alle = document.getElementById('lbo-alle');
    if (alle) alle.addEventListener('click', function () {
      var a = modtaget || laes();
      if (!a.length) return;
      alle.textContent = 'Lægger i kurv…';
      Promise.all(a.map(hent)).then(function (ps) {
        var items = ps.filter(Boolean).map(function (pd) {
          var v = pd.variants.filter(function (x) { return x.available; })[0];
          return v ? { id: v.id, quantity: 1 } : null;
        }).filter(Boolean);
        if (!items.length) { alle.textContent = 'Ingen på lager'; return; }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items, sections: 'cart-icon-bubble' })
        }).then(function (r) { return r.json(); }).then(function (j) {
          if (j.sections && j.sections['cart-icon-bubble']) saetBoble(j.sections['cart-icon-bubble']);
          alle.textContent = 'Lagt i kurv ✓';
          setTimeout(function () { alle.textContent = 'Læg det hele i kurven'; }, 2400);
        });
      }).catch(function () {
        alle.textContent = 'Prøv igen';
        setTimeout(function () { alle.textContent = 'Læg det hele i kurven'; }, 2400);
      });
    });

    window.addEventListener('resize', function () {
      pilStyr('lbo-liste');
      pilStyr('lbo-forslag-liste');
    });

    var runder = 0;
    var ur = setInterval(function () {
      runder++;
      kortHjerter();
      produktHjerte();
      if (runder >= 20) clearInterval(ur);
    }, 900);
    window.addEventListener('load', function () { kortHjerter(); produktHjerte(); });
    document.addEventListener('shopify:section:load', function () { kortHjerter(); produktHjerte(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
